import React from "react";
import NumberFormat from 'react-number-format';
import TextField from "@material-ui/core/TextField";
import { useTranslation } from "react-i18next";


export default function CoafMoneyTextField(props) {
    const { t } = useTranslation()
    const { label = "" } = props
    const { value = 0 } = props
    const { readOnly = false } = props
    const { onChange } = props

    return (
        <NumberFormat
            value={value}
            customInput={TextField}
            onValueChange={onChange}
            thousandSeparator={t("thousands_separator")}
            decimalSeparator={t("decimal_separator")}
            allowNegative={false}
            decimalScale={0}
            fixedDecimalScale={true}
            placeholder={"R$ 0"}
            prefix="R$ "
            label={t(label)}
            InputLabelProps={{ shrink: true, readOnly: readOnly}}
            inputProps={{readOnly: readOnly}}
            readOnly={readOnly}
        />
    )
}